import * as React from 'react';
import { NavLink } from 'react-router-dom';
import { LinkBar } from './LinkBar/LinkBar';

export type TOnClick = (to: string) => void;

export interface IReportNavBarOption {
  onClick: TOnClick;
  text: string;
  to: string;
}

export interface IReportNavBarProps {
  options: IReportNavBarOption[];
}

export const ReportNavBar = (props: IReportNavBarProps) => {
  return (
    <LinkBar>
      {props.options.map((opt) => {
        const onClick = (event: React.MouseEvent<HTMLAnchorElement>) => {
          event.preventDefault();
          opt.onClick(opt.to);
        };
        return (
          <NavLink
            key={opt.to}
            className="nav-button"
            activeClassName="nav-button--active"
            to={opt.to}
            onClick={onClick}
          >
            {opt.text}
          </NavLink>
        );
      })}
    </LinkBar>
  );
};

export default ReportNavBar;
